import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {ScheduledSingleVoyagesLazy} from "@containers/singleVoyage/scheduledVoyages/ScheduledSingleVoyages.lazy";

const ScheduledSingleVoyagesPage = () => {
    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <ScheduledSingleVoyagesLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default ScheduledSingleVoyagesPage;